import * as React from 'react';

export function NotepadTextIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			strokeLinejoin='round'
			strokeLinecap='round'
			strokeWidth={2}
			stroke='currentColor'
			fill='none'
			viewBox='0 0 24 24'
			width={24}
			height={24}
			{...props}
		>
			<path d='M8 2v4' />
			<path d='M12 2v4' />
			<path d='M16 2v4' />
			<rect width='16' height='18' x='4' y='4' rx='2' />
			<path d='M8 10h6' />
			<path d='M8 14h8' />
			<path d='M8 18h5' />
		</svg>
	);
}
